import React from 'react';
import { BRAND, PRODUCT, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-solar bg-coal" data-id="element-68" data-mp="3gfiuujlrgden">
      <div className="mx-auto max-w-3xl px-3 py-4 text-center sm:px-6" data-id="element-69" data-mp="3gh3qydnq44em">
        <p className="text-[0.7rem] font-black uppercase tracking-[0.12em] text-solar sm:text-[0.74rem]" data-id="element-70" data-mp="32pfg0dp7nlz8">
          © 2026 {BRAND} — Todos los Derechos Reservados.
        </p>
        <p className="mt-1.5 font-body text-[0.66rem] leading-snug text-white/70 sm:text-[0.7rem]" data-id="element-71" data-mp="3ug3efhzi2d97">
          {PRODUCT} es un producto educativo de {BRAND}. Los resultados dependen
          del estudio, práctica y experiencia de cada alumno. El programa no
          constituye una certificación, matrícula o habilitación profesional.
          Las instalaciones deben cumplir la normativa aplicable y ser
          realizadas o supervisadas por profesionales habilitados cuando
          corresponda.
        </p>
        <p className="mt-1.5 text-[0.7rem] text-white sm:text-[0.74rem]" data-id="element-72" data-mp="2ez1nyn6mln4n">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-solar underline underline-offset-2" data-id="element-73" data-mp="3labt60db0esh">
            {SUPPORT_EMAIL}
          </a>{' '}
          • Términos y Condiciones • Política de Privacidad • Contacto
        </p>
      </div>
    </footer>;
}